import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-wp-bg border-t border-wp-border">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <p className="text-sm text-wp-muted">&copy; {new Date().getFullYear()} WallPass. All Rights Reserved.</p>
        <div className="text-sm">
          <Link to="/publisher/login" className="text-wp-muted hover:text-wp-accent transition-colors">For Publishers</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
